import PropTypes from 'prop-types'
import { SupportedThirdPartyServices } from '../../models/common/supported-third-party-services'

/**
 * Proptype defining the rest model for a webfleet-access-token
 *
 * @typedef {Object} WebfleetAccessToken
 * @property {SupportedThirdPartyServices} application    - The identifier for the service this token is valid for.
 * @property {string} expirationTime                      - ISO date string defining when token expires
 * @property {string} tokenValue                          - The token
 * @property {string} webfleetAccountName                 - The account name of the webfleet user requesting this token
 * @property {string} webfleetUserName                    - The webfleet user name requesting the token
 */
export const webfleetAccessTokenPropType = PropTypes.shape({
    application: PropTypes.oneOf(SupportedThirdPartyServices).isRequired,
    expirationTime: PropTypes.string.isRequired,
    tokenValue: PropTypes.string.isRequired,
    webfleetAccountName: PropTypes.string.isRequired,
    webfleetUserName: PropTypes.string.isRequired
})
